import { styled, theme } from '@clickcease/cc-client-components-lib'

export const CurrentPlanWrapper = styled('div', {
  display: 'flex',
  fontWeight: '$sb',
  fontSize: '$lg',
  flexDirection: 'column',
})

export const CurrentPlanTitle = styled('div', {})

export const CurrentPlanPrice = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',
  marginTop: '$1',
})

export const PlanPriceBold = styled('span', {
  fontWeight: '$rb',
})

export const CurrentPlanDetailsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  fontWeight: '$l',
  marginTop: '$4',
  fontSize: '$md',
  gap: '$1',
})

export const CurrentPlanDetailsRow = styled('div', {})

export const PlanList = styled(CurrentPlanDetailsWrapper, {
  marginTop: '0',
  marginBottom: '$4',
  gap: '$2',
})

export const PlanListItem = styled(CurrentPlanDetailsWrapper, {
  marginTop: '0',
  gap: '$2',
  marginBottom: '$8',
})

export const InlineFlex = styled('div', {
  display: 'flex',
  gap: '$2',
  alignItems: 'center',
})

export const PlanNameItem = styled('div', {
  fontWeight: '$rb',
  fontSize: '$md',
})

export const PlanClicksItem = styled(CurrentPlanDetailsRow, {})

export const LoaderContainer = styled('div', {
  display: 'flex',
  justifyContent: 'left',
  paddingLeft: '$4',
  marginBottom: '$6',

  '> svg': {
    height: theme.space['16'].value,
  },
})

export const SwitchPaymentInterval = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  fontWeight: '$l',
  marginTop: '$4',
  fontSize: '$md',
  gap: '$1',
  color: 'var(--colors-primaryColor)',
  textDecoration: 'underline',
  cursor: 'pointer',
  maxWidth: '350px',
})

export const SwitchPaymentIntervalContainerModal = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '570px',
  height: '180px',
  padding: '$12',
})
export const SwitchPaymentIntervalContainerBody = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '$9',
})

export const SwitchPaymentIntervalError = styled('div', {
  color: '$error',
  fontSize: '$md',
  marginTop: '$5',
  fontWeight: '$l',
})
